import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import StaffLogin from "@/pages/StaffLogin";
import StudentLogin from "@/pages/StudentLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Schools from "@/pages/admin/Schools";
import Content from "@/pages/admin/Content";
import ManageStudents from "@/pages/teacher/ManageStudents";
import TeacherDashboard from "@/pages/teacher/TeacherDashboard";
import StudentDetail from "@/pages/teacher/StudentDetail";
import StudentHome from "@/pages/student/StudentHome";
import TakeTest from "@/pages/student/TakeTest";
import ResultPage from "@/pages/student/ResultPage";

const Guard = ({ roles, children }) => {
  const { auth } = useAuth();
  if (auth === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (auth === false) return <Navigate to="/" replace />;
  if (!roles.includes(auth.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/staff-login" element={<StaffLogin />} />
          <Route path="/student-login" element={<StudentLogin />} />
          <Route path="/admin" element={<Guard roles={["super_admin"]}><AdminDashboard /></Guard>} />
          <Route path="/admin/schools" element={<Guard roles={["super_admin"]}><Schools /></Guard>} />
          <Route path="/admin/content" element={<Guard roles={["super_admin"]}><Content /></Guard>} />
          <Route path="/teacher" element={<Guard roles={["teacher"]}><TeacherDashboard /></Guard>} />
          <Route path="/teacher/students" element={<Guard roles={["teacher"]}><ManageStudents /></Guard>} />
          <Route path="/teacher/student/:id" element={<Guard roles={["teacher", "super_admin"]}><StudentDetail /></Guard>} />
          <Route path="/student" element={<Guard roles={["student"]}><StudentHome /></Guard>} />
          <Route path="/student/test/:testId" element={<Guard roles={["student"]}><TakeTest /></Guard>} />
          <Route path="/result/:attemptId" element={<Guard roles={["student", "teacher", "super_admin"]}><ResultPage /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
